import { createI18n } from 'vue-i18n';
import pl from '@/translation/locale/pl/';
import validationMessages from '@/translation/locale/pl/validationMessages.json';

export const messages = {
    pl: {
        ...pl,
        validation: {
            ...validationMessages
        }
    }
};

export const i18n = createI18n({
    locale: 'pl',
    messages,
    legacy: false
});
